/**
 * Gets a map of default set of attributes to observe and the properties they affect.
 *
 * @param inputs  A collection of property name and template name for the inputs of a component
 *
 * @returns       A map of attributes that are associated with the inputs of the component
 */
export function getDefaultAttributeToPropertyInputs(inputs: ReadonlyArray<{ propName: string, templateName: string }>): { [key: string]: string } {
  let value: { [key: string]: string } = {}

  inputs.forEach(({ propName, templateName }) => {
    templateName = templateName.replace(/[A-Z]/g, char => `-${ char.toLowerCase() }`)
    value[templateName] = propName
  })

  return value
}
